import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-467b832f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "or", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "or", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Loading annotations")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Error loading annotations")
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 3,
  class: "results"
}
const _hoisted_7 = ["tabindex"]
const _hoisted_8 = { class: "table" }
const _hoisted_9 = { class: "truncate" }

import { onMounted } from "vue";
import { useLocalStorage } from "@vueuse/core";
import { kebabCase, uniqBy } from "lodash";
import AppTextbox from "@/components/AppTextbox.vue";
import AppUpload from "@/components/AppUpload.vue";
import example from "./text-annotator.json";
import { annotateText } from "@/api/text-annotator";
import { downloadJson } from "@/util/download";
import { appendToBody } from "@/global/tooltip";
import { useQuery } from "@/util/composables";

/** text content */

export default /*#__PURE__*/_defineComponent({
  __name: 'TextAnnotator',
  setup(__props) {

const content = useLocalStorage("annotations-content", "");
/** file name of uploaded file (if applicable) */
const filename = useLocalStorage("annotations-filename", "");

/** annotation results */
const {
  query: annotate,
  data: annotations,
  isLoading,
  isError,
} = useQuery(async function () {
  return await annotateText(content.value);
}, []);

/** get text content and filename from upload button */
async function onUpload(data = "", file = "") {
  content.value = data;
  filename.value = file;
  await annotate();
}

/** on textbox change */
async function onChange() {
  filename.value = "";
  await annotate();
}

/** example full text */
async function doExample() {
  content.value = example.content;
  filename.value = "Example";
  await annotate();
}

/** download annotations */
function download() {
  downloadJson(
    annotations.value.filter(({ tokens }) => tokens.length),
    "annotations"
  );
}

/** get phenotype annotations to send to phenotype explorer */
function getPhenotypes() {
  /** gather annotations that are phenotypes */
  const phenotypes = [];
  for (const { tokens } of annotations.value)
    for (const { id, name } of tokens)
      if (id.startsWith("HP:")) phenotypes.push({ id, name });

  /** de-duplicate, and send them to phenotype explorer component via router */
  return uniqBy(phenotypes, "id");
}

/** run annotations on mount if content loaded from storage */
onMounted(async () => {
  if (content.value) await annotate();
});

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppFlex = _resolveComponent("AppFlex")!
  const _component_AppSection = _resolveComponent("AppSection")!
  const _component_AppStatus = _resolveComponent("AppStatus")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppLink = _resolveComponent("AppLink")!
  const _component_tooltip = _resolveComponent("tooltip")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(AppTextbox, {
          modelValue: _unref(content),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(content) ? (content).value = $event : null)),
          multi: true,
          icon: "file-lines",
          placeholder: "Paste full text",
          onChange: onChange
        }, null, 8, ["modelValue"]),
        _createVNode(_component_AppFlex, null, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(AppUpload, { onUpload: onUpload }),
            _hoisted_2,
            _createVNode(_component_AppButton, {
              text: "Try an example",
              design: "small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (doExample()))
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        (_unref(isLoading))
          ? (_openBlock(), _createBlock(_component_AppStatus, {
              key: 0,
              code: "loading"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isError))
          ? (_openBlock(), _createBlock(_component_AppStatus, {
              key: 1,
              code: "error"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(annotations).length)
          ? (_openBlock(), _createElementBlock("strong", _hoisted_5, "Annotations for " + _toDisplayString(_unref(filename) || "pasted text"), 1))
          : _createCommentVNode("", true),
        (_unref(annotations).length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(annotations), ({ text, tokens }, annotationIndex) => {
                return (_openBlock(), _createBlock(_component_tooltip, {
                  key: annotationIndex,
                  interactive: true,
                  "append-to": _unref(appendToBody)
                }, _createSlots({
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      tabindex: tokens.length ? 0 : -1
                    }, _toDisplayString(text), 9, _hoisted_7)
                  ]),
                  _: 2
                }, [
                  (!!tokens.length)
                    ? {
                        name: "content",
                        fn: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tokens, (token, tokenIndex) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: tokenIndex }, [
                                _createVNode(_component_AppIcon, {
                                  icon: `category-${_unref(kebabCase)(token.category)}`
                                }, null, 8, ["icon"]),
                                _createVNode(_component_AppLink, {
                                  to: `/${_unref(kebabCase)(token.category)}/${token.id}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(token.id), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _createElementVNode("div", _hoisted_9, _toDisplayString(token.name), 1)
                              ], 64))
                            }), 128))
                          ])
                        ])
                      }
                    : undefined
                ]), 1032, ["append-to"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_unref(annotations).length)
          ? (_openBlock(), _createBlock(_component_AppFlex, { key: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_AppButton, {
                  text: "Download",
                  icon: "download",
                  onClick: download
                }),
                _withDirectives(_createVNode(_component_AppButton, {
                  to: "#phenotype-explorer",
                  state: { phenotypes: getPhenotypes() },
                  text: "Analyze Phenotypes",
                  icon: "bars-progress"
                }, null, 8, ["state"]), [
                  [_directive_tooltip, 
          'Send any annotations above that are phenotypes to Phenotype Explorer'
        ]
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})